import { TRuleWithTheme } from 'styles/theme';

export const picker: TRuleWithTheme = ({ theme }) => ({
    '&.ant-picker-range': {
        margin: 0,
        paddingTop: '.5rem',
        paddingBottom: '.5rem',
    },
});
